import angular from 'angular';
import CarsNgTracking from 'cars-ng-tracking';
import CarsNgBrowser from 'cars-ng-browser';
import CarsNgActiveTest from '../carsNgActiveTest';
import ConsumerProfile from 'cars-ng-consumer-profile';

import component from './vdpAbandonCapture.component';

export default angular.module('vdp.abandonCapture', [
    'cars.ui.angular',
    CarsNgTracking,
    CarsNgBrowser,
    CarsNgActiveTest,
    ConsumerProfile
])

.component('carsVdpAbandonCapture', component)

.name;
